import m from "../../es2015/lang/sl_SL";
window.am4lang_sl_SL = m;


//////////////////
// WEBPACK FOOTER
// ./lang/sl_SL.js
// module id = null
// module chunks = 